import { Routes } from '@angular/router'

/** Default: no dev routes. angular.json swaps in pa-dev-routes.enabled.ts for dev, qa and quickfix. */
export const PA_DEV_ROUTES: Routes = []
